import React from 'react';
import toolsBanner from '../assets/images/tools-banner.jpg'; // Banner Image
import emiIcon from '../assets/images/emi-icon.png'; // Icon for Loan EMI Calculator
import eligibilityIcon from '../assets/images/eligibility-icon.png'; // Icon for Loan Eligibility Checker
import rateComparisonIcon from '../assets/images/rate-comparison-icon.png'; // Icon for Interest Rate Comparison
import debtRatioIcon from '../assets/images/debt-ratio-icon.png'; // Icon for Debt-to-Income Ratio Evaluator
import savingsIcon from '../assets/images/savings-icon.png'; // Icon for Savings Goal Tracker

const Tools = () => {
  const toolsData = [
    {
      title: 'Loan EMI Calculator',
      description: 'Easily calculate your loan EMI and plan your finances better.',
      link: '/tools/loan-emi-calculator',
      icon: emiIcon,
    },
    {
      title: 'Loan Eligibility Checker',
      description: 'Determine your loan eligibility quickly with this tool.',
      link: '/tools/loan-eligibility-checker',
      icon: eligibilityIcon,
    },
    {
      title: 'Interest Rate Comparison Tool',
      description: 'Compare interest rates to choose the best financial option.',
      link: '/tools/interest-rate-comparison',
      icon: rateComparisonIcon,
    },
    {
      title: 'Debt-to-Income Ratio Evaluator',
      description: 'Evaluate your debt-to-income ratio to manage your finances.',
      link: '/tools/debt-to-income-ratio',
      icon: debtRatioIcon,
    },
    {
      title: 'Savings Goal Tracker',
      description: 'Track your savings and achieve your financial goals.',
      link: '/tools/savings-goal-tracker',
      icon: savingsIcon,
    },
  ];

  return (
    <div style={{ padding: '50px', fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif", lineHeight: '1.8' }}>
      {/* Banner Section */}
      <div style={{ textAlign: 'center', marginBottom: '40px' }}>
        <h1 style={{ fontSize: '36px', marginBottom: '20px', color: '#22225f' }}>AI Financial Tools</h1>
        <img
          src={toolsBanner}
          alt="AI Tools"
          style={{
            width: '100%',
            height: 'auto',
            borderRadius: '10px',
            marginBottom: '30px',
            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
          }}
        />
        <p style={{ maxWidth: '800px', margin: '0 auto', fontSize: '18px', color: '#555' }}>
          Discover our advanced AI-powered financial tools, designed to simplify complex decisions and empower you with
          data-driven insights. From EMI planners to savings trackers, we have you covered!
        </p>
      </div>

      {/* Tools Section */}
      <div style={{ maxWidth: '1200px', margin: '0 auto', textAlign: 'left' }}>
        <h3 style={{ fontSize: '24px', marginBottom: '20px', color: '#22225f' }}>Available Tools:</h3>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '20px',
          }}
        >
          {toolsData.map((tool, index) => (
            <div
              key={index}
              style={{
                backgroundColor: '#fff',
                border: '1px solid #ddd',
                borderRadius: '10px',
                padding: '20px',
                textAlign: 'center',
                boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
                transition: 'transform 0.3s, box-shadow 0.3s',
                cursor: 'pointer',
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = 'scale(1.05)';
                e.currentTarget.style.boxShadow = '0 4px 10px rgba(0, 0, 0, 0.2)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = 'scale(1)';
                e.currentTarget.style.boxShadow = '0 2px 5px rgba(0, 0, 0, 0.1)';
              }}
              onClick={() => window.open(tool.link, '_blank')}
            >
              {/* Tool Icon */}
              <img
                src={tool.icon}
                alt={tool.title}
                style={{ width: '80px', height: '80px', marginBottom: '20px' }}
              />
              {/* Tool Title */}
              <h4 style={{ fontSize: '20px', color: '#22225f', marginBottom: '10px' }}>{tool.title}</h4>
              {/* Tool Description */}
              <p style={{ fontSize: '16px', color: '#555', marginBottom: '0' }}>{tool.description}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Floating WhatsApp Chat Button */}
      <a
        href="https://wa.me/917569523497?text=Hello!%20I%20would%20like%20to%20know%20more%20about%20your%20financial%20tools."
        target="_blank"
        rel="noopener noreferrer"
        style={{
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          width: '60px',
          height: '60px',
          backgroundColor: '#25d366',
          borderRadius: '50%',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000,
        }}
      >
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
          alt="WhatsApp"
          style={{ width: '40px', height: '40px' }}
        />
      </a>
    </div>
  );
};

export default Tools;
